module.exports = {"371311001":"罗庄街道","371311002":"傅庄街道","371311003":"盛庄街道","371311006":"册山街道","371311007":"高都街道","371311100":"沂堂镇","371311101":"褚墩镇","371311102":"黄山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371311.json
// module id = 1458
// module chunks = 0